import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AddUserDialogComponent } from '../../add-user-dialog/add-user-dialog.component';
import { TreeCheckedNode } from 'projects/shared/src/lib/models/ProjectTreeChecked';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource, MatTreeNestedDataSource } from '@angular/material/tree';
import { ExampleFlatNode } from 'projects/shared/src/lib/models/ProjectTree';

const PROJECTS: TreeCheckedNode[] = [
  {
    id: 'p1',
    name: 'Projekt1',
    checked: true,
    isParent: true,
    children: [{id: 'pgr1', name: 'PGR11', checked: true, isParent: false}, {id: 'pgr2', name: 'PGR12', checked: true, isParent: false}, {id: 'pgr1', name: 'PGR13', checked: true, isParent: false}],
  },
  {
    id: 'p2',
    name: 'Projekt2',
    checked: true,
    isParent: true,
    children: [
      {
        id: 'pgr3',
        name: 'PGR21',
        checked: true,
        isParent: false
      },
      {
        id: 'pgr4',
        name: 'PGR22',
        checked: true,
        isParent: false
      },
    ],
  },
];

@Component({
  selector: 'app-select-userpermission-dialog',
  templateUrl: './select-userpermission-dialog.component.html',
  styleUrls: ['./select-userpermission-dialog.component.css']
})

export class SelectUserpermissionDialogComponent implements OnInit {

  private _transformer = (node: TreeCheckedNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      // id: node.id,
      level: level,
    };
  };

  treeControl = new NestedTreeControl<TreeCheckedNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<TreeCheckedNode>();

  // treeControl = new FlatTreeControl<ExampleFlatNode>(
  //   node => node.level,
  //   node => node.expandable,
  // );
  // dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );


  //hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  hasChild = (_: number, node: TreeCheckedNode) => !!node.children && node.children.length > 0;

  anzAllProjRolePairs = 0;

  constructor(
    private formBuilder: FormBuilder,
    // public _dialogRef: MatDialogRef<AddUserDialogComponent>,
    public _dialogRef: MatDialogRef<SelectUserpermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // source userId (von diesem User wird übernommen)
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService
  ) { }

  ngOnInit() {
    console.log("----------> select-userpermission: from userId ", this.data)
    //this.dataSource.data = PROJECTS;
    this.tenantService.getUserProjectsAndGrouprolesChecked(this.tenantService.tempTenantName, this.data).subscribe({
      next: (treeNode: TreeCheckedNode[]) => {
        console.log("-----> select-userpermission: treeNode = ", treeNode)
        this.dataSource.data = treeNode;
        const allProjRolePairs = this.getCheckedNodeIds();
        this.anzAllProjRolePairs = allProjRolePairs.length;
        console.log('Alle Proj Role IDs:', this.anzAllProjRolePairs);    
      },
      error: (error: any) => {
        //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
      }
    });

  }

  toggleCheck(node: TreeCheckedNode) {
    node.checked = !node.checked;
    if (node.children) {
      this.toggleChildrenCheck(node, node.checked);
    }
    this.updateTreeNodeStatus(node, this.getParentNode(node));
    }

  toggleChildrenCheck(node: TreeCheckedNode, checked: boolean) {
    node.children?.forEach(child => {
      child.checked = checked;
      this.toggleChildrenCheck(child, checked);
    });
  }

  updateTreeNodeStatus(node: TreeCheckedNode, parent?: TreeCheckedNode) {
    // Wenn der aktuelle Knoten ein Child ist, aktualisiere seinen Parent
    if (parent) {
      this.updateParentStatus(parent);
    }
  
    // Falls der Knoten Kinder hat, prüfe ihre Zustände
    if (node.children) {
      node.children.forEach((child) => {
        this.updateTreeNodeStatus(child, node);
      });
    }
  }

  updateParentStatus(node: TreeCheckedNode) {
    if (node.children) {
      // Prüfe, ob alle Child-Knoten deaktiviert sind
      const allChildrenUnchecked = node.children.every((child) => !child.checked);
  
      // Aktualisiere den Status des Parent-Knotens
      node.checked = !allChildrenUnchecked;
    }
  }
  
  getParentNode(node: TreeCheckedNode): TreeCheckedNode | undefined {
    let parent: TreeCheckedNode | null = null;
  
    const findParent = (currentNode: TreeCheckedNode, currentParent: TreeCheckedNode | null) => {
      if (currentNode === node) {
        parent = currentParent;
        return;
      }
      if (currentNode.children) {
        currentNode.children.forEach((child) => findParent(child, currentNode));
      }
    };
  
    this.dataSource.data.forEach((rootNode) => findParent(rootNode, null));
    return (parent != null)?parent:undefined;
  }
  
  
  cancel(){
    this._dialogRef.close();
  }
  add(){
      const checkedProjRolePairs = this.getCheckedNodeIds();
      console.log('Aktivierte Proj Role IDs:', checkedProjRolePairs.length);    
      this._dialogRef.close(checkedProjRolePairs);
    }

  getCheckedNodeIds(): string[] {
    const projRolePairs: string[] = [];
    let parentId: string = "";
  
    const collectCheckedIds = (nodes: TreeCheckedNode[]) => {
      nodes.forEach((node) => {
        //console.log("-----> getCheckedNodeIds: each Node = ",node)
        if (node.checked) {
          if (node.isParent) {
            parentId = node.id;
          }
          else {
            //console.log("-----> getCheckedNodeIds: parentId != node.id? " ,parentId + " " + node.id)
            if (parentId != node.id) {
              //console.log("-----> getCheckedNodeIds: Pairs push = ", parentId+"|"+node.id+"|"+node.name)
              projRolePairs.push(parentId+"|"+node.id+"|"+node.name);
            }
          }
        }
        if (node.children) {
          collectCheckedIds(node.children); 
        }
      });
    };
  
    collectCheckedIds(this.dataSource.data); 
    return projRolePairs;
  }
  
}
